module.exports = __webpack_public_path__ + "img/vd-lollipop.5083ae73.svg";